import React, { createContext, useContext, useState, ReactNode } from 'react';
import { getPersistedValue, setPersistedValue } from 'shared/utils/persisted-values';

type LoginNudgeContextType = {
  isDismissed: boolean;
  dismissNudge: () => void;
};

const LoginNudgeContext = createContext<LoginNudgeContextType | undefined>(undefined);

const SESSION_STORAGE_KEY = 'login-nudge-dismissed';

type LoginNudgeProviderProps = {
  children: ReactNode;
};

export const LoginNudgeProvider = ({ children }: LoginNudgeProviderProps): JSX.Element => {
  const [isDismissed, setIsDismissed] = useState<boolean>(getPersistedValue(SESSION_STORAGE_KEY, false));

  const dismissNudge = (): void => {
    setIsDismissed(true);
    setPersistedValue(SESSION_STORAGE_KEY, true, true);
  };

  return <LoginNudgeContext.Provider value={{ isDismissed, dismissNudge }}>{children}</LoginNudgeContext.Provider>;
};

export const useLoginNudgeContext = (): LoginNudgeContextType => {
  const context = useContext(LoginNudgeContext);
  if (context === undefined) {
    throw new Error('useLoginNudgeContext must be used within a LoginNudgeProvider');
  }
  return context;
};
